<script setup lang="ts">
    import type { PrimitiveProps } from "reka-ui";

    import { type HTMLAttributes, ref } from "vue";

    import type { ButtonVariants } from "@/components/shadcn/ui";

    import { Button } from "@/components/shadcn/ui";
    import { Spinner } from "@/components/shadcn/ui/spinner";

    import router from "@/router";

    interface Props extends PrimitiveProps {
        loadFunction?: () => Promise<unknown>;

        to?: string;

        variant?: ButtonVariants["variant"];
        size?: ButtonVariants["size"];
        class?: HTMLAttributes["class"];
    }

    const props = withDefaults(defineProps<Props>(), {
        as: "button",
    });

    const loading = ref<boolean>(false);

    const executeLoadFunction = async () => {
        loading.value = true;

        await props.loadFunction?.();

        loading.value = false;

        if(props.to) {
            await router.push(props.to);
        }
    }
</script>

<template>
    <Button :disabled="loading" @click="executeLoadFunction" v-bind="props">
        <div
            class="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0"
            :class="{ 'opacity-0': loading }"
        >
            <slot/>
        </div>

        <Spinner class="size-6 stroke-3 absolute" :class="{ 'opacity-0': !loading }"/>
    </Button>
</template>

<style scoped lang="scss">

</style>